import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { tenantAPI } from '../api/client';
import DevicesCard from '../components/DevicesCard';
import PasswordCard from '../components/PasswordCard';
import ProfileCard from '../components/ProfileCard';
import { useTenant } from '../context/TenantContext';
import { apiError } from '../lib/host';
import { seatsUsed } from '../lib/limits';
import { formatRupees } from '../lib/plans';
import { usePlanLabel } from '../lib/usePlans';
import './AdminDashboard.css';

/** Overview for owners and admins. */
export default function TenantOverview() {
  const planLabel = usePlanLabel();
  const location = useLocation();
  const { tenant, can } = useTenant();
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    tenantAPI.stats().then((res) => setStats(res.data)).catch((err) => setError(apiError(err)));
  }, []);

  const tiles = [
    { label: 'Active Members', value: stats && seatsUsed(stats.active_members, stats.max_members), icon: '👥', color: '#667eea' },
    { label: 'Pending Invitations', value: stats?.pending_invitations, icon: '✉️', color: '#f6ad55' },
    { label: 'Plan', value: stats && planLabel(stats.plan), icon: '📦', color: '#764ba2' },
    { label: 'Monthly Cost', value: stats && formatRupees(stats.monthly_price), icon: '💰', color: '#48bb78' },
    { label: 'Joined This Month', value: stats?.joined_this_month, icon: '📈', color: '#4299e1' },
  ];

  return (
    <>
      {location.state?.success && <div className="tcx-success">{location.state.success}</div>}
      {error && <div className="admin-error">{error}</div>}
      <div className="admin-tiles-grid">
        {tiles.map((tile) => (
          <div key={tile.label} className="admin-tile" style={{ borderTopColor: tile.color }}>
            <div className="admin-tile-icon">{tile.icon}</div>
            <div className="admin-tile-value" style={{ textTransform: 'capitalize' }}>{tile.value ?? '—'}</div>
            <div className="admin-tile-label">{tile.label}</div>
          </div>
        ))}
      </div>

      <section className="tcx-panel">
        <h3>Next steps</h3>
        <div className="tcx-actions">
          {can('members.invite') && <Link className="tcx-btn" to="/members">Invite teammates</Link>}
          {can('billing.manage') && <Link className="tcx-btn secondary" to="/subscription">Change plan</Link>}
          {can('settings.write') && <Link className="tcx-btn secondary" to="/settings">Feature flags & audit log</Link>}
        </div>
      </section>

      <ProfileCard tenantName={tenant.name} />
      <PasswordCard />
      <DevicesCard />
    </>
  );
}
